import { useQuery } from '@tanstack/react-query';

import { fetchShipmentFieldsVisibility } from '../data-provider/shipment-fields-visibility';

export const useGetShipmentFieldsVisibility = (customerKey: number, enabled: boolean = true) => {
  return useQuery({
    enabled: enabled && Boolean(customerKey),
    queryFn: () => fetchShipmentFieldsVisibility(),
    queryKey: ['shipment-fields-visibility', customerKey],
    // biome-ignore lint/style/noMagicNumbers: 3 minutes
    staleTime: 1000 * 60 * 3,
  });
};
